import scrollToBlock from '@functions/scrollToBlock.js';

import I from '../types.ts';

const init: I['init'] = async function () {
    const { setPagesKey, device } = this.props;

    setPagesKey();

    this.parent.current!.querySelectorAll('._ancor').forEach((ancor) => {
        const ancorNode = ancor as HTMLElement;

        ancorNode.onclick = () => {
            const id = ancor.getAttribute('data-ancor');

            const block = this.parent.current!.querySelector(`._ancorBlock[data-ancor="${id}"]`);

            if (block) {
                scrollToBlock({
                    scrollBlock: this.parent.current!.closest('.public__innerPage'),
                    block,
                    offset: device === 'mobile' ? 100 : 100,
                });
            }
        };
    });
};

export default init;
